import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LcsDateRangePickerInputPanelContentFormValue } from '@lcs/shared/datepicker';
import { Subject } from 'rxjs';
import { LcsDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/date-time-adapter';
import {
   DateRangeParameterFormModel,
   DateRangeReportParameterValue,
} from '../models/date-range-report-parameter-value';
import { ReportParameterConfig } from '../report-parameter-list/report-parameter.config';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-date-range-report-parameter',
    templateUrl: './date-range-report-parameter.component.html',
    standalone: false
})
export class DateRangeReportParameterComponent implements OnDestroy {
   @Input() requireInput = true;

   @Input() customLabel = '';

   config: ReportParameterConfig;

   contentFormValue: LcsDateRangePickerInputPanelContentFormValue<Date>;

   // dateRangePickerOptions = dateRangePickerOptions(new LcsNativeDateAdapter(this.dateAdapter));

   set form(form: UntypedFormGroup) {
      this._form = form;
      const formValue: DateRangeParameterFormModel = this.form.value;
      this.initializeContentFormValue();
   }

   get form(): UntypedFormGroup {
      return this._form;
   }

   get label() {
      return this.config?.label;
   }

   private _form: UntypedFormGroup;

   constructor(private formBuilder: UntypedFormBuilder, private dateAdapter: LcsDateTimeAdapter<Date>) {}

   private destroyed$ = new Subject<void>();

   ngOnDestroy(): void {
      // QMG-3199 - Once updated to angular v12+ we can remove this code to handle cleaning up form controls
      // https://github.com/angular/angular/issues/27803
      const formValue: DateRangeParameterFormModel = this.form.value;

      this.form.removeControl('startDate');
      this.form.removeControl('endDate');

      const dateRangeReportParameterValue: DateRangeReportParameterValue = {
         endDate: formValue.endDate,
         startDate: formValue.startDate,
      };

      const startDate: UntypedFormControl = this.formBuilder.control(dateRangeReportParameterValue.startDate);
      const endDate: UntypedFormControl = this.formBuilder.control(dateRangeReportParameterValue.endDate);

      this.form.addControl('startDate', startDate);
      this.form.addControl('endDate', endDate);
      // -------------------------------------------------------------------------------------------------
      this.destroyed$.next();
   }

   onContentFormValueChange(contentFormValue: LcsDateRangePickerInputPanelContentFormValue<Date>): void {
      this.form.patchValue({
         relativeDate: contentFormValue.datePickerOption?.id ?? null,
      });
   }

   private initializeContentFormValue(relativeDate?: null): void {
      if (relativeDate == null) {
         return;
      }
      const optionId = relativeDate;
      // const dateRangePickerOption = this.dateRangePickerOptions.find((option) => {
      //    return option.id === optionId;
      // });

      // if (dateRangePickerOption) {
      //    const dateRange = dateRangePickerOption.callback();

      //    this.form.patchValue({
      //       endDate: dateRange.endDate,
      //       startDate: dateRange.startDate,
      //    });

      //    this.contentFormValue = {
      //       datePickerOption: dateRangePickerOption,
      //       dateRange,
      //    };
      // }
   }
}
